import * as React from 'react';
import { CaseListingResultList } from './case-listing-result-list';
import { CaseResult } from 'app/area/case-report/case-listing/types-store';
import { PrimaryActionComponentFactory } from 'app/area/case-report/case-listing/types';
import { HeaderVisibilityConfiguration } from 'app/components';
import { RenderMode } from 'app/types-shared';
import { CaseReportListingInformation } from 'app/area/case-report/components/case-report-listing-information';

interface CaseListingResultOrInfoProps {
  translation: any;
  autoExecute: boolean;
  results?: CaseResult[];
  totalNumberOfResults?: number;
  fetching: boolean;
  windowAsScrollableAncestor?: boolean;
  primaryActionComponentFactory: PrimaryActionComponentFactory;
  headerVisibilityConfiguration: HeaderVisibilityConfiguration;
  fetchMoreData: () => void;
  renderMode: RenderMode;
}

export const CaseListingResultOrInfo = ({
  translation, 
  autoExecute,
  results, 
  totalNumberOfResults, 
  fetching,
  windowAsScrollableAncestor = true,
  primaryActionComponentFactory, 
  headerVisibilityConfiguration,
  fetchMoreData,
  renderMode
}: CaseListingResultOrInfoProps) => {

  if (autoExecute) {
    return <CaseListingResultList
      translation={translation}
      results={results}
      totalNumberOfResults={totalNumberOfResults}
      fetching={fetching}
      windowAsScrollableAncestor={windowAsScrollableAncestor}
      fetchMoreData={fetchMoreData}
      primaryActionComponentFactory={primaryActionComponentFactory}
      headerVisibilityConfiguration={headerVisibilityConfiguration}
      renderMode={renderMode}
    />;
  }
  return <CaseReportListingInformation 
    translation={translation} />;
};
